import { useGetS12nCourseMemberships } from 'bundles/enroll-common/hooks/useGetS12nCourseMemberships';

type CourseLike = {
  id: string;
  slug: string;
};

/**
 * Hook to return the course used for the enroll CTA, based on the learner's enrollment status
 */
export const useGetCourseForEnrollButton = <Course extends CourseLike>({
  course,
  isSpecialization,
  isEnrolled,
  s12nCourses,
}: {
  course?: Course;
  isSpecialization: boolean;
  isEnrolled: boolean;
  s12nCourses?: Course[];
}): Course | undefined => {
  const { mostRecentS12nCourseMembership } = useGetS12nCourseMemberships({
    courses: s12nCourses,
    skip: !isEnrolled || !isSpecialization,
  });

  // For standalone course and course-in-s12ns, use the specific course
  if (!isSpecialization && course) {
    return course;
  }

  // For s12ns that the learner is enrolled in, use the most recently enrolled course-in-s12n
  if (isEnrolled) {
    return (
      s12nCourses?.find((s12nCourse) => mostRecentS12nCourseMembership?.courseId === s12nCourse.id) ?? s12nCourses?.[0]
    );
  }

  // For s12ns that the learner is not enrolled in, use the first course-in-s12n
  return s12nCourses?.[0];
};
